import React, { useContext, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import { Container, Row, Button, Form } from "react-bootstrap";
import Banner from "../../components/banner/banner";
import FormFrame from "../../components/form/form";
import "./email.css";
import { AuthContext } from "../../App";
import Error from "../error/error";
import { initUserClinic } from "../../utils/api";
import { authentication } from "../../utils/config";
import "../../components/button/button.css";
import Header from "../../components/header/header";

const Email = (props) => {
  const lineProfile = useContext(AuthContext);
  const navigate = useNavigate();
  const preEmail = localStorage.getItem("email");
  const [inputData, setInputData] = useState(preEmail);
  const [isShowCount, setIsShowCount] = useState(false);
  const [countdown, setCountdown] = useState(30);
  const [buttonUnable, setButtonUnable] = useState(false);
  // to constrain vertification times
  const conuntDownFunciton = (time) => {
    let countdown = time;
    setCountdown(countdown);
    setButtonUnable(true);
    setIsShowCount(true);
    const timer = setInterval(() => {
      countdown--;
      setCountdown(countdown);
      localStorage.setItem("countdown", countdown);
      if (countdown <= 0) {
        clearInterval(timer);
        setButtonUnable(false);
        setIsShowCount(false);
      }
    }, 1000);
  };

  useEffect(() => {
    const auth = async () => {
      const response = await authentication(lineProfile.userId, "no user");
      console.log("call api");
      if (response.error || response.data === "no lineId")
        return navigate("/error");
      else if (response.created === true) return navigate("/main");
      else if (response.data === "vertified") return navigate("/register");
    };
    auth();

    const storedCountdown = localStorage.getItem("countdown");
    if (storedCountdown) {
      setCountdown(parseInt(storedCountdown));
      setIsShowCount(true);
      conuntDownFunciton(parseInt(storedCountdown));
    }
  }, []);

  if (!lineProfile) {
    return navigate("/error");
  }

  const handleChange = (e) => {
    const { name, value } = e.target;
    setInputData(value);
    localStorage.setItem("email", value);
    console.log(inputData);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const response = await initUserClinic(lineProfile, inputData);
    if (response.error) {
      await Swal.fire({
        title: "系統錯誤",
        text: JSON.stringify(response.data),
        icon: "error",
      });
    } else {
      conuntDownFunciton(30);
      await Swal.fire({
        title: "設定成功",
        text: "請至email驗證信件",
        icon: "success",
      });
    }
  };

  return (
    <>
      <Container
        fluid
        style={{ minHeight: "100vh", backgroundColor: "#E4F4F3" }}
      >
        <Row>
          <Banner />
        </Row>
        <div className="email-header-container">
          <Header title="電子信箱驗證" className=""></Header>
        </div>
        <Row style={{ marginTop: "10%", height: "50%" }}>
          <div>
            <div className="email-form-container">
              <Form.Group className="mb-3 ">
                <Form.Label>電子信箱</Form.Label>

                <Form.Control
                  type="email"
                  placeholder="輸入email"
                  onChange={handleChange}
                  value={inputData}
                  name="email"
                  required={true}
                />
                <Form.Text className="text-muted">
                  <p className="text-danger fs-6">
                    <b>
                      ※電子信箱驗證之後即無法任意修改，請務必寫公司/診所用信箱或常用信箱
                    </b>
                  </p>
                </Form.Text>
              </Form.Group>
            </div>

            <div
              className="text-center"
              style={{ visibility: isShowCount ? "visible" : "hidden" }}
            >
              <p className="h5">重新發送認證信: {countdown} 秒</p>
            </div>
            <div className="w-100 w-sm-50 mx-auto d-flex justify-content-center m-0">
              <Button
                className="btn-custom-green w-50"
                disabled={buttonUnable}
                onClick={handleSubmit}
              >
                發送驗證信
              </Button>
            </div>

            {isShowCount && (
              <div className="w-100 w-sm-50 mx-auto d-flex justify-content-center mt-1">
                <Button
                  className="btn-custom-white w-50"
                  onClick={() => navigate("/register")}
                >
                  驗證完成
                </Button>
              </div>
            )}
          </div>
        </Row>
        {}
      </Container>
    </>
  );
};
export default Email;
